export default "__VITE_ASSET__D3t5lzl$__"